import React, { Component } from 'react';
import { Button } from 'reactstrap';
import './overlay.scss';

class Overlay extends Component {
    hideOverlay = () => {
        this.props.overlayCallback()
    }

    render() {
        let openOverlay = this.props.isOpen;
        /* const footerBtn='';
        const data = '';
        const cls = ''; */
        if (openOverlay) {
            this.footerBtn = (
                <footer className="overlay-footer">
                    <Button block color="secondary">Close</Button>
                </footer>
            );
            this.cls = "overlay";
        } else {
            this.footerBtn = null;
            this.cls = "d-none";
        }
        return (
            <div className={this.cls} onClick={this.hideOverlay}>
                {/* {this.props.children}
                {this.footerBtn} */}
            </div>
        );
    }
}

export default Overlay;
